import React, { useState, ReactElement, Dispatch, SetStateAction } from 'react'
import cn from 'classnames'
import s from './PromoBanner.module.scss'
import { useCookies } from 'react-cookie'

interface PromoBannerProps {
    maxAge?: number
    cookieName: string
    className?: string
    closeButton?: ReactElement | string
    setIsPromoCookieCleared?: Dispatch<SetStateAction<boolean>>
    isPromoCookieCleared?: boolean
}

export const PromoBanner: React.FC<PromoBannerProps> = ({
    children,
    maxAge = 86400,
    cookieName,
    className,
    closeButton
}) => {
    // The useCookies argument is called "dependencies"
    // Whenever these cookies are updated from any component, this component will re-render
    const [cookies, setCookie] = useCookies([cookieName])

    // `cookies` is an object with all of the app's cookies. The key is the cookie name
    const [closed, setClosed] = useState(!!cookies[cookieName])

    const handleClose = () => {
        setClosed(true)
        setCookie(cookieName, 'closed', {
            path: '/',
            maxAge: maxAge
        })
    }

    return (
        <div>
            {!closed && (
                <div className={cn(s['promo-banner'], className)}>
                    <div className={s['promo-banner-text']}>
                        {children}

                        <span
                            className={s['promo-banner-button']}
                            onClick={handleClose}
                            aria-hidden="true"
                        >
                            {closeButton}
                        </span>
                    </div>
                </div>
            )}
        </div>
    )
}
